import { render, staticRenderFns } from "./infoPublic.vue?vue&type=template&id=0cda9bb1&scoped=true"
import script from "./infoPublic.vue?vue&type=script&lang=js"
export * from "./infoPublic.vue?vue&type=script&lang=js"
import style0 from "./infoPublic.vue?vue&type=style&index=0&id=0cda9bb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cda9bb1",
  null
  
)

export default component.exports